/* ══════════════════════════════════════════════════════════════
   Pokémon Singles Megamenu — accordion toggles
   Scoped to .nav-item--pokemon-singles only.
   New file — does not touch any existing theme JS.
   ══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var SCOPE = '.nav-item--pokemon-singles';

  function init() {
    var container = document.querySelector(SCOPE);
    if (!container) return;

    /* Older-sets accordion toggles */
    container.querySelectorAll('.mega-singles__older-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('expanded');
        var list = btn.nextElementSibling;
        if (list) list.classList.toggle('mega-singles__show');
      });
    });
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
